let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bpktO")).then(() => parcelRequire('gBarX'));